"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const victory_1 = require("victory");
const layout_1 = require("../../layout");
const styled_1 = require("../../styled");
const theme_1 = require("../../theme");
const theme_2 = require("@atlaskit/theme");
const LABEL_MARGIN = theme_2.gridSize();
exports.FONT_FAMILY = "Helvetica Neue";
const CHART_HEIGHT = 400;
class Plot extends React.Component {
    render() {
        const { xScaleType, yScaleType, domainPadding, xLabel, yLabel, plotLabel, padding, tickCount, xDomain, aspectRatio } = this.props;
        const width = CHART_HEIGHT * aspectRatio;
        return (React.createElement(theme_1.ThemeContextConsumer, null, ({ mode }) => {
            const textColor = mode === "light" ? theme_2.colors.N800 : theme_2.colors.DN800;
            return (React.createElement(layout_1.Card, null,
                React.createElement(styled_1.TextAlignCenterDiv, null,
                    React.createElement("h4", null, plotLabel)),
                React.createElement(victory_1.VictoryChart, { width: width, height: CHART_HEIGHT, domainPadding: domainPadding, scale: { x: xScaleType, y: yScaleType }, domain: xDomain, containerComponent: React.createElement(victory_1.VictoryVoronoiContainer, { responsive: true, labelComponent: React.createElement(victory_1.VictoryTooltip, { style: {
                                fontFamily: exports.FONT_FAMILY
                            }, flyoutStyle: {
                                stroke: "none",
                                fill: theme_2.colors.N40
                            } }), labels: ({ datum }) => `${xScaleType === "time"
                            ? new Date(datum._voronoiX).toDateString()
                            : datum._voronoiX}, ${datum._voronoiY}` }), padding: padding },
                    React.createElement(victory_1.VictoryLabel, { text: xLabel, x: width / 2, y: CHART_HEIGHT - LABEL_MARGIN, textAnchor: "middle", style: { fontWeight: "bold", fontFamily: exports.FONT_FAMILY } }),
                    React.createElement(victory_1.VictoryLabel, { text: yLabel, x: LABEL_MARGIN, y: CHART_HEIGHT / 2, textAnchor: "middle", angle: -90, style: { fontWeight: "bold", fontFamily: exports.FONT_FAMILY } }),
                    React.createElement(victory_1.VictoryAxis, { dependentAxis: false, scale: xScaleType, style: {
                            axis: { stroke: textColor },
                            axisLabel: { fill: textColor },
                            tickLabels: {
                                fontFamily: exports.FONT_FAMILY,
                                fontSize: 12,
                                fill: textColor
                            }
                        } }),
                    React.createElement(victory_1.VictoryAxis, { style: {
                            axis: { stroke: textColor },
                            axisLabel: { fill: textColor },
                            grid: {
                                stroke: mode === "light" ? theme_2.colors.N100 : theme_2.colors.DN100,
                                strokeWidth: 0.5
                            },
                            tickLabels: {
                                fontFamily: exports.FONT_FAMILY,
                                fontSize: 12,
                                fill: textColor
                            }
                        }, dependentAxis: true, tickFormat: y => Math.round(y), tickCount: tickCount, scale: yScaleType }),
                    this.props.children)));
        }));
    }
}
exports.Plot = Plot;
Plot.defaultProps = {
    aspectRatio: 1.25,
    xScaleType: "linear",
    yScaleType: "linear",
    padding: 50
};
